import React, { useEffect, useRef } from 'react';
import { NavLink } from "react-router-dom";
import { vesselType } from '../../../../../util/varibles/constants';
import { getElById } from '../../../../../util/varibles/global';
import { IVessel } from '../../../../../util/varibles/interface';
import { CALENDAR_ID } from '../../../constants';
import styles from '../style.module.scss';

interface IProps {
    data: IVessel & { isPermission: boolean }
}

const Vessel: React.FC<IProps> = ({ data }) => {
    const { name, type, id, isPermission } = data;
    const { name: nameVesselType = '' } = vesselType[type] || {};
    const rootRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const rootEl = rootRef.current;
        const parent = rootEl?.parentElement;

        if (!rootEl || !parent) return;

        const handleEnter = () => {
            const calendarEl = getElById(CALENDAR_ID);
            if (calendarEl && calendarEl.dataset.dragging !== "true")
                parent.dataset.hover = "true";
        };

        const handleLeave = () => {
            delete parent.dataset.hover
        };

        rootEl.addEventListener('mouseenter', handleEnter);
        rootEl.addEventListener('mouseleave', handleLeave);

        return () => {
            rootEl.removeEventListener('mouseenter', handleEnter);
            rootEl.removeEventListener('mouseleave', handleLeave);
        };
    }, [])

    const style = {
        height: `calc(var(--${id}, 0px) + var(--more-height, 0px))`
    }

    return <div className={styles.vessel} style={style} data-is-permission={isPermission} data-scroll-vessel-id={id}>
        <div ref={rootRef} className='w-full'>
            <NavLink to={"/vessel/" + id}>{name}</NavLink>
            <p>{nameVesselType}</p>
        </div>
    </div>;
};

export default Vessel;
